<template>
  <!--查看-->
  <el-form :model="detailOptions" size="mini" label-width="140px" class="form-horizontal flex-column detail-form paddingTopDetail detail-text-form">
    <div class="detail-box" style="display: flex;flex-wrap: wrap; ">
      <el-form-item v-for="(item,key) in detailData[0]" :key="'aa00der_'+key"  prop="service_code" :class="item.className" :label="item.label+'：'" label-width="160px">
        {{item.value}}
      </el-form-item>
    </div>
    <div style="text-align: center;padding: 10px;">
      <a @click="handleMoreClick" class="line-icon-btn">查看此人更多入住记录 ></a>
    </div>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="订单信息" name="1">
        <div class="detail-box" style="display: flex;flex-wrap: wrap; ">
          <el-form-item v-for="(item,key) in detailData[1]" :key="'aader_'+key" prop="service_code" :class="item.className" :label="item.label+'：'" label-width="160px">
            {{item.value}}
          </el-form-item>
        </div>
      </el-collapse-item>
    </el-collapse>
  </el-form>
</template>

<script>
    export default {
        name: "virtualPersonDetailModel",
        props:{
          delete_uuid: {
            type: String,
            default:''
          },
          detailModal:{
            type:Boolean,
            default:''
          },
          detailData:{
            type:Array,
            default:[]
          }
        },
        data(){
          return{
            activeNames: ['1','2','3'],
          }
      },
      mounted(){
          console.log(this.detailData,'dteta')
      },
      watch:{

      },
      methods:{
        handleMoreClick(){
          this.$emit('showMore',this.detailData[0][0].value)
        }
      },
    }
</script>

<style lang="less" scoped>
  .detail-form .el-form-item{
    width: 48%;
  }
</style>
